export const calculateProgress = (steps) => {
    if (!Array.isArray(steps)) {
        return { completed: 0, total: 0 };
    }
    const totalSteps = steps.length;
    const completedSteps = steps.filter(step => step.completed).length;
    return { completed: completedSteps, total: totalSteps };
}

export const removeSpaces = (str) => {
    return str.replace(/\s+/g, '');
}

export const calculateProgressPercentage = (completed, total) => {
    return total > 0 ? Math.round((completed / total) * 100) : 0;
}

export const arraysAreEqual = (arr1, arr2) => {
    return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
}

export const shuffleArray = (array) => {
    let shuffledArray = [...array];
    do {
        for (let i = shuffledArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
        }
    } while (arraysAreEqual(shuffledArray, array));
    return shuffledArray;
}

export const enterFullscreen = (video) => {
    if (video.requestFullscreen) {
        video.requestFullscreen();
    } else if (video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen();
    } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
    } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
    } else {
        alert("Fullscreen API is not supported by this browser.");
    }
}

export const addAttempt = ( uuid, correct = false ) => {
    return {
        timestamp: Date.now(),
        uuid,
        correct
    }
}
export const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000); // Convert to milliseconds
    return date.toLocaleDateString('nl-NL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).replace(/\//g, '-');
};

export const generateInitials = (firstname, lastname) => {
    if (!firstname) return '';
    const names = firstname.split(' ');
    const lastNameParts = lastname ? lastname.split(' ') : [''];
    let initials = '';

    if (names.length > 1 && ["van", "der", "de", "di", "la", "von", "le", "du"].includes(names[0].toLowerCase())) {
        initials += names[0].charAt(0).toUpperCase();
        initials += names[names.length - 1].charAt(0).toUpperCase();
    } else {
        initials += names[0].charAt(0).toUpperCase();
    }

    if (lastNameParts.length > 0) {
        if (lastNameParts.length > 1 && ["van", "der", "de", "di", "la", "von", "le", "du"].includes(lastNameParts[0].toLowerCase())) {
            initials += lastNameParts[lastNameParts.length - 1].charAt(0).toUpperCase();
        } else {
            initials += lastNameParts[0].charAt(0).toUpperCase();
        }
    }

    return initials.length > 2 ? initials.slice(0, 2) : initials;
};